import React from 'react';
import PropTypes from 'prop-types';

const DigitalHealthPlatforms = ({ platforms }) => {
  return (
    <section className="py-10 md:py-14 lg:py-18 bg-white">
      <div className="container mx-auto px-8 md:px-16 lg:px-24 max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-bold mb-4 md:mb-6 text-3xl">
            <span className="text-[#1A2B6D]">Our Digital </span>
            <span className="text-[#1a6bbf]">Health Platforms</span>
          </h2>
          <p className="text-[#1A2B6D] opacity-80 max-w-5xl mx-auto">
            Purpose-built digital platforms designed to address diverse healthcare needs and deliver connected, patient-centric care.
          </p>
        </div>

        {/* Cards Container */}
        <div className="space-y-6 md:space-y-8">
          {/* First Row - 3 Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {platforms.slice(0, 3).map((platform, index) => (
              <PlatformCard key={index} platform={platform} />
            ))}
          </div>

          {/* Second Row - 2 Cards Centered */}
          <div className="grid grid-cols-1 md:grid-cols-6 gap-5 md:gap-6">
            <div className="hidden md:block md:col-span-1"></div>
            {platforms.slice(3, 5).map((platform, index) => (
              <div key={index + 3} className="md:col-span-2">
                 <PlatformCard platform={platform} />
              </div>
            ))}
            <div className="hidden md:block md:col-span-1"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

/* Internal Card Component to avoid repeating code */
const PlatformCard = ({ platform }) => (
  <div className="group relative rounded-lg overflow-hidden shadow-lg h-56 md:h-64 cursor-pointer transition-all duration-300 hover:shadow-2xl">
    {/* Background Image */}
    <div className="absolute inset-0">
      <img
        src={platform.image}
        alt={platform.title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
    </div>

    {/* Title Overlay (Visible by default, fades out on hover) */}
    <div className="absolute bottom-0 left-0 right-0 bg-white p-3 md:p-4 z-10 opacity-100 group-hover:opacity-0 transition-opacity duration-300">
      <h3 className="text-center font-semibold text-[#1A2B6D]">
        {platform.title}
      </h3>
    </div>

    {/* Hover Overlay (Fades in on hover) */}
    {/* Using bg-[#1A2B6D]/95 for background transparency without affecting text sharpness */}
    <div className="absolute inset-0 bg-[#1A2B6D]/95 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-5 md:p-6 z-20">
      <h3 className="text-white font-bold mb-2 text-center text-sm uppercase tracking-wider">
        {platform.title}
      </h3>
      <p className="text-white text-xs leading-relaxed text-center">
        {platform.description}
      </p>
    </div>
  </div>
);

DigitalHealthPlatforms.propTypes = {
  platforms: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DigitalHealthPlatforms;